import { useState, useRef } from "react";
import { Checkbox } from "antd";

function SentenceEngCheck ({_, record, singleChange, field}) {
  const [checkStatus, setCheckStatus] = useState(_)
  const compareRef = useRef(checkStatus)
  return (
    <Checkbox
      checked={checkStatus === "Y" ? true : false}
      style={{
        border:
        checkStatus === record[`${field}_origin`] ? "" : "solid 2px red",
      }}
      onChange={(e)=>{
        const checked = e.target.checked ? "Y" : "N"
        setCheckStatus(checked)
      }}
      onMouseEnter={()=>{
        compareRef.current = checkStatus
      }}
      onMouseLeave={(e)=>{
        if(compareRef.current !== checkStatus) {
          singleChange(checkStatus, record, field);
        }
      }}
      
    />
  )
}

export default SentenceEngCheck